<div class="validation-display" [ngClass]="classes" *ngIf="ctrl">
    <bk-validation-display-element *ngFor="let item of itemsArray" [item]="item"></bk-validation-display-element>
</div>
<div *ngIf="missingCtrl">Where is bkFormControl?</div>
